export default "__VITE_ASSET__76c7f49a__"